import React from 'react';
import { Box, Container, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import {
  DEFAULT_TRUST_POINTS,
  type TrustPointContent,
} from '../../../shared/homepage/searchFirstDefaults';
import { AGENCY_SHELL_HORIZONTAL_PX } from '../../constants/layoutSpacing';

export type TrustPointsSectionProps = {
  title?: string;
  items?: TrustPointContent[] | null;
};

const TrustPointsSection: React.FC<TrustPointsSectionProps> = ({
  title = 'Why American Police Training?',
  items,
}) => {
  const points =
    items && items.length >= 3
      ? [...items].sort((a, b) => a.sort_order - b.sort_order)
      : DEFAULT_TRUST_POINTS;

  return (
    <Box sx={{ py: { xs: 5, md: 7 }, bgcolor: 'background.default', px: AGENCY_SHELL_HORIZONTAL_PX }}>
      <Container maxWidth="sm" disableGutters>
        <Typography
          variant="h2"
          component="h2"
          sx={{
            fontWeight: 800,
            fontSize: { xs: '1.5rem', md: '2.25rem' },
            mb: 3,
            textAlign: 'center',
          }}
        >
          {title}
        </Typography>
        <List>
          {points.map((point) => (
            <ListItem key={point.id} sx={{ py: 0.75 }}>
              <ListItemIcon sx={{ minWidth: 40 }}>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText
                primary={point.label}
                primaryTypographyProps={{ fontWeight: 600, fontSize: '1.05rem' }}
              />
            </ListItem>
          ))}
        </List>
      </Container>
    </Box>
  );
};

export default TrustPointsSection;
